import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

import { getDocumentDownloadTokenService, uploadDocumentService, uploadImageService } from "@/services/files.service";
import { IAPIResponse } from "@/services/api.types";
import { DownloadTokenResponse, UploadDocumentResponse, UploadImageResponse } from "@/types/files.types";

export const filesQueryKeys = {
  all: () => ["files"] as const,
};

export const usePostUploadImage = () => {
  return useMutation<IAPIResponse<UploadImageResponse>, Error, File>({
    mutationFn: uploadImageService,
    retry: false,
    onError: err => toast.error(err.message),
  });
};

export const usePostUploadDocument = () => {
  return useMutation<IAPIResponse<UploadDocumentResponse>, Error, File>({
    mutationFn: uploadDocumentService,
    retry: false,
    onError: err => toast.error(err.message),
  });
};

export const usePostDocumentDownloadToken = () => {
  return useMutation<IAPIResponse<DownloadTokenResponse>, Error, string>({
    mutationFn: getDocumentDownloadTokenService,
    retry: false,
    onError: err => toast.error(err.message),
  });
};
